<!--  -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" :content="title">
    </el-page-header>
    <div class="help">
      <p>90个工作日内，可被转接分配2次</p>
    </div>
    <div class="mMain">
      <div class="navbar">
        <div class="nav-l">
          <el-button type="primary" icon="el-icon-s-promotion" @click="onFenPei"
            >分配</el-button
          >
          <div
            style="width: 27.0rem; margin-left: 3.0rem; display: inline-flex"
            @click.stop="onSelectPerson"
          >
            <el-input
              v-model="person.name"
              placeholder="选择分配群"
              suffix-icon="el-icon-arrow-down"
              @click.stop
            >
            </el-input>
          </div>
        </div>
        <div class="nav-r">
          <el-input
            clearable
            style="width: 35.0rem; margin: 0 .0rem 0 .0rem"
            v-model="search"
            prefix-icon="el-icon-search"
            placeholder="请搜索群名称"
            @change="onSearch"
          >
          <el-button slot="append" type="primary" @click="onSearch()"
            >搜索</el-button
          >
          </el-input>
          
        </div>
      </div>
      <div class="container">
        <el-table
          ref="multipleTable"
         
          :data="tableData"
          row-key="id"
          tooltip-effect="dark"
          style="margin-top: 2.0rem"
          border
          @selection-change="onSelection"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="群名称"></el-table-column>
          <el-table-column prop="owner_name" label="群主"></el-table-column>
          <el-table-column prop="gruop_count" label="群人数"></el-table-column>
          <el-table-column prop="status" label="群状态"></el-table-column>
          <el-table-column
            prop="label_group_name"
            label="群标签"
            style="width: 50%"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.isTagEmpty">
                {{ scope.row.label_group_name }}
              </div>
              <div v-else>
                <el-tag
                  size="mini"
                  style="margin: .2rem"
                  v-for="(i, index) in scope.row.label_group_name"
                  :key="index"
                  >{{ i }}</el-tag
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="创建时间"
            width="240"
          ></el-table-column>
          <el-table-column label="操作" fixed="right" width="170">
            <template slot-scope="scope">
              <el-button
                @click="onToDetail(scope.row)"
                size="mini"
                type="text"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          @pagination="getContactUsers"
        />
      </div>
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "departureInheritanceGroup",
  components: {
    Pagination,
    rightPeople
  },
  data() {
    return {
      search: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      multipleSelection: [],
      userid: "",
      title: "",
      person: {
        name: "",
        id: "",
      },
      module: "",
      checkbox: false,
      pPath: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log(to);
    next((vm) => {
      vm.pPath = from.name;
    });
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.title = `${this.$route.query.name}-${this.$route.query.department_name}`;
    this.getContactUsers();
  },
  methods: {
    onToDetail(row){
      this.$router.push({
        name: "clientBaseDetail",
        query: {
          chat_id: row.chat_id,
        },
      });
    },   
    goBack() {
      this.$router.go(-1);
    },
    onSelectPerson() {
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.person = person;
    },
    onFenPei() {
      if (!this.person.userid) {
        this.$message("请选择要分配的群主");
        return;
      }
      if (!this.multipleSelection.length) {
        this.$message("请选择群");
        return;
      }

      this.$confirm(`您确定要分配给${this.person.name}吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.onDistribute();
        })
        .catch(() => {});
    },
    async getContactUsers() {
      const { data: res } = await this.axios({
        url: "/crm/Assistant/getClientBaseList",
        method: "POST",
        data: qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          userid: this.$route.query.userid,
          name: this.search,
          page: this.listQuery.page,
          number_page:this.listQuery.limit,
        }),
      });
      if (res.code == 1) {
        res.data.data.forEach((i) => {
          const isTagEmpty = i.label_group_name.includes("暂无");
          i.isTagEmpty = isTagEmpty;
          if (!isTagEmpty) {
            i.label_group_name = i.label_group_name.split(",");
          }
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    onSelection(val) {
      this.multipleSelection = val;
    },
    onSearch() {
      this.getContactUsers();
    },
    async onDistribute() {
      const chat_id_list = this.multipleSelection.map((i) => {
        return i.chat_id;
      });
      let url;
      if (this.pPath == "departureInheritance") {
        // 离职继承页面过来
        url = "/crm/Dimission/transfer";
      } else if (this.pPath == "departureInheritance2") {
        // 在职继承页面过来
        url = "/crm/Dimission/onjob_transfer";
      }

      const { data: res } = await this.axios({
        url: url,
        method: "POST",
        data: qs.stringify({
          account_id: this.tooken.account_id,
          chat_id_list: chat_id_list.toString(),
          new_owner: this.person.userid,
        }),
      });
      this.$message({
        message: res.msg,
        type: res.code == 1 ? "success" : "error",
      });
      if (res.code == 1 && res.msg == "分配成功") {
        this.$router.go(-1);
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },
};
</script>
<style scoped>
.container {
  margin-top: 2.0rem;
}
.help{
  padding: 1.5rem;
  border-radius: 1.0rem;
  margin-bottom: 2.0rem;
}
</style>